import React from 'react';
import type { SelectChangeEvent } from '@mui/material';
import { Box, useTheme } from '@mui/material';
import SelectBase from '../../../../../../primeX-underwriter/components/footer/SelectBase';
import SimpleTooltip from '../../../../../../../../components/SimpleTooltip';
import {
  ReferralStrategyForEdit,
  ReferralStrategyVariant,
} from '../../types';
import { REFERRAL_STRATEGY_DROPDOWN_STYLES } from './styles/referralStrategyDropdown.styles';
import {
  getReferralStrategyLabel,
  MIXED_VALUE,
} from './utils/referralStrategyDropdown.utils';
import { useCategoryReferralStrategy } from './hooks/referralStrategyDropdown.hooks';

type CategoryReferralStrategyDropdownProps = {
  variant:
    | ReferralStrategyVariant.CATEGORY_COVERAGE
    | ReferralStrategyVariant.CATEGORY_RATING_OPTION;
  keys: string[];
};

function CategoryReferralStrategyDropdown({
  variant,
  keys,
}: CategoryReferralStrategyDropdownProps) {
  const theme = useTheme();
  const { displayValue, options, handleStrategyChange } =
    useCategoryReferralStrategy(variant, keys);

  if (keys.length === 0) {
    return null;
  }

  const handleChange = (
    e: SelectChangeEvent<ReferralStrategyForEdit | typeof MIXED_VALUE>
  ) => {
    const newStrategy = e.target.value;

    if (newStrategy === MIXED_VALUE) {
      return;
    }

    handleStrategyChange(newStrategy as ReferralStrategyForEdit);
  };

  const renderValue = (selected: unknown) => {
    const value = selected as ReferralStrategyForEdit | typeof MIXED_VALUE;
    const label = getReferralStrategyLabel(value);
    return (
      <Box
        sx={{
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        }}
      >
        {label}
      </Box>
    );
  };

  return (
    <Box display="flex" alignItems="center" gap="0.5rem">
      <SimpleTooltip title="Referral Strategy" placement="top">
        <SelectBase
          options={options}
          name={variant}
          value={displayValue}
          onChange={handleChange}
          sx={REFERRAL_STRATEGY_DROPDOWN_STYLES.select(theme)}
          MenuProps={{
            PaperProps: {
              sx: REFERRAL_STRATEGY_DROPDOWN_STYLES.menu,
            },
          }}
          renderValue={renderValue}
        />
      </SimpleTooltip>
    </Box>
  );
}

export default CategoryReferralStrategyDropdown;

